/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */
import React from "react";
import _get from "lodash/get";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import FormSubmit from "../../Common/FormSubmit/FormSubmit";
import DeathIcon from "../../../../assets/icons/familyLaw/toggleable/IconChurch";
import FamilyIcon from "../../../../assets/icons/generic/toggleable/IconFamilyDetailed";
import BothIcon from "../../../../assets/icons/familyLaw/toggleable/IconBoth";
import YesIcon from "../../../../assets/icons/common/toggleable/IconCheck";
import NoIcon from "../../../../assets/icons/common/toggleable/IconClose";
import InheritanceIcon from "../../../../assets/icons/familyLaw/toggleable/IconInheritance";
import DocumentIcon from "../../../../assets/icons/provision/toggleable/IconDocumentPlus";
import Hidden from "@mui/material/Hidden";
import FormFader from "../../Common/Fader/FormFader";
import { useForm } from "../../../../provider/Form/FormProvider";
import Group from "../../../Wizard/Group";
import { requiredValidator } from "../../../../services/validationRules";
import Typography from "@mui/material/Typography";
import FormSubmitProps from "../../../../types/FormSubmitProps";
import wizardStyle from "../../wizardStyle";
import { Box } from "@mui/material";

type CategoriesProps = { submitProps: FormSubmitProps };

export default function Categories({ submitProps }: CategoriesProps) {
  const { values, handleSubmit } = useForm();
  return (
    <Paper sx={wizardStyle.paper} elevation={4}>
      <FormFader>
        <Box component={"form"} sx={{ ...wizardStyle.applicationForm, ...wizardStyle.wizardForm }} onSubmit={handleSubmit}>
          <Hidden smUp>
            <Typography variant={"h4"} sx={wizardStyle.headline}>
              Todesfall/Erbe
            </Typography>
          </Hidden>
          <Grid container justifyContent={"center"}>
            <Grid item xs={12}>
              <Group
                type="radio"
                name="generalCategory"
                question="Worüber möchten Sie sich informieren?"
                options={[
                  {
                    labelText: "Todesfall",
                    labelIcon: <DeathIcon />,
                    labelIconActive: <DeathIcon active />,
                    value: "death",
                  },
                  {
                    labelText: "Erbe",
                    labelIcon: <FamilyIcon />,
                    labelIconActive: <FamilyIcon active />,
                    value: "inheritance",
                  },
                  {
                    labelText: "Über beide Themen",
                    labelIcon: <BothIcon />,
                    labelIconActive: <BothIcon active />,
                    value: "both",
                  },
                ]}
                validators={[requiredValidator("Bitte wählen Sie eine der angezeigten Antworten aus")]}
              />
            </Grid>
            {["death", "both"].includes(_get(values, "generalCategory")) && (
              <Grid item xs={12}>
                <Group
                  type="radio"
                  name="deathCategory"
                  question="Hat der Todesfall sich bereits ereignet?"
                  options={[
                    {
                      labelText: "Ja, ich muss mich aktuell um einen Todesfall kümmern",
                      labelIcon: <YesIcon />,
                      labelIconActive: <YesIcon active />,
                      value: "current",
                    },
                    {
                      labelText: "Nein, aber ich möchte auf den Ernstfall vorbereitet sein",
                      labelIcon: <NoIcon />,
                      labelIconActive: <NoIcon active />,
                      value: "preparation",
                    },
                  ]}
                  validators={[requiredValidator("Bitte wählen Sie eine der angezeigten Antworten aus")]}
                />
              </Grid>
            )}
            {["inheritance", "both"].includes(_get(values, "generalCategory")) && (
              <Grid item xs={12}>
                <Group
                  type="radio"
                  name="inheritanceCategory"
                  question="Sind Sie Erbe oder möchten Sie Ihren eigenen Nachlass verwalten?"
                  options={[
                    {
                      labelText: "Ich bin Erbe und habe dazu Fragen",
                      labelIcon: <InheritanceIcon />,
                      labelIconActive: <InheritanceIcon active />,
                      value: "heir",
                    },
                    {
                      labelText: "Ich möchte meinen Nachlass verwalten/mein Erbe vorbereiten",
                      labelIcon: <DocumentIcon />,
                      labelIconActive: <DocumentIcon active />,
                      value: "bequeather",
                    },
                  ]}
                  validators={[requiredValidator("Bitte wählen Sie eine der angezeigten Antworten aus")]}
                />
              </Grid>
            )}
          </Grid>
          <FormSubmit {...submitProps} />
        </Box>
      </FormFader>
    </Paper>
  );
}
